var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTop3Tuan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 84,
    height: 84,
    rx: 15,
    fill: "url(#paint0_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2 21V26.1007H68V33.3684C68 39.6145 63.372 44.7424 57.4062 45.5686C56.5517 48.0987 55.0361 50.3487 53.0195 52.0808C51.003 53.8129 48.5604 54.9628 45.95 55.4089V58.1053C45.95 59.4174 46.4662 60.6758 47.3852 61.6036C48.3041 62.5314 49.5504 63.0526 50.85 63.0526H53.3V68H33.7V63.0526H36.15C37.4496 63.0526 38.6959 62.5314 39.6148 61.6036C40.5338 60.6758 41.05 59.4174 41.05 58.1053V55.4089C38.4396 54.9628 35.997 53.8129 33.9805 52.0808C31.9639 50.3487 30.4483 48.0987 29.5938 45.5686C23.628 44.7424 19 39.6145 19 33.3684V26.1007H28.8V21H58.2ZM23.9 31.0481V33.3684C23.9016 34.9025 24.3735 36.3985 25.2508 37.6511C26.1282 38.9036 27.368 39.8513 28.8 40.364V31.0481H23.9ZM61.749 37.6519C62.6262 36.399 63.0981 34.9028 63.1 33.3684V31.0481H58.2V40.3665C59.632 39.853 60.8717 38.9048 61.749 37.6519ZM40.475 46.225C41.4417 46.7417 42.55 47 43.8 47C44.9 47 45.9083 46.7583 46.825 46.275C47.7417 45.775 48.475 45.1 49.025 44.25C49.575 43.3833 49.85 42.4083 49.85 41.325C49.85 40.1583 49.55 39.125 48.95 38.225C48.3667 37.3083 47.4167 36.625 46.1 36.175C46.6 35.9417 47.075 35.65 47.525 35.3C47.975 34.9333 48.3417 34.5 48.625 34C48.925 33.5 49.075 32.925 49.075 32.275C49.075 31.3583 48.8417 30.5417 48.375 29.825C47.925 29.0917 47.3 28.5167 46.5 28.1C45.7167 27.6667 44.8333 27.45 43.85 27.45C42.7833 27.45 41.8167 27.675 40.95 28.125C40.0833 28.5583 39.4 29.1583 38.9 29.925C38.4 30.6917 38.15 31.5583 38.15 32.525C38.15 32.8917 38.2583 33.2 38.475 33.45C38.7083 33.6833 38.9833 33.8 39.3 33.8C39.6333 33.8 39.9083 33.675 40.125 33.425C40.3417 33.1583 40.45 32.8333 40.45 32.45C40.45 31.9333 40.6 31.4667 40.9 31.05C41.2167 30.6333 41.6333 30.3 42.15 30.05C42.6833 29.8 43.2667 29.675 43.9 29.675C44.7333 29.675 45.4167 29.925 45.95 30.425C46.4833 30.925 46.75 31.5417 46.75 32.275C46.75 32.7917 46.6083 33.2583 46.325 33.675C46.0417 34.075 45.6833 34.4 45.25 34.65C44.8167 34.8833 44.3667 35 43.9 35C43.5333 35 43.225 35.125 42.975 35.375C42.7417 35.6083 42.625 35.9083 42.625 36.275C42.625 36.6417 42.7417 36.95 42.975 37.2C43.225 37.45 43.5333 37.575 43.9 37.575C44.55 37.575 45.1333 37.7417 45.65 38.075C46.1667 38.4083 46.575 38.8583 46.875 39.425C47.175 39.975 47.325 40.6 47.325 41.3C47.325 42.4 46.9833 43.2583 46.3 43.875C45.6333 44.475 44.75 44.775 43.65 44.775C42.9 44.775 42.225 44.6083 41.625 44.275C41.025 43.925 40.55 43.4667 40.2 42.9C39.85 42.3167 39.675 41.6833 39.675 41C39.675 40.6167 39.5667 40.3083 39.35 40.075C39.1333 39.825 38.8583 39.7 38.525 39.7C38.2083 39.7 37.9333 39.825 37.7 40.075C37.4833 40.3083 37.375 40.6167 37.375 41C37.375 42.1333 37.65 43.1583 38.2 44.075C38.75 44.975 39.5083 45.6917 40.475 46.225Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 18,
    y: 21,
    width: 51,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 44,
    y1: 1,
    x2: 44,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1B1B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop3Tuan);
export default __webpack_public_path__ + "static/media/Top3tuan.881b61c8d4c1e32aa9af046b32740380.svg";
export { ForwardRef as ReactComponent };